module.exports = __webpack_public_path__ + "static/media/55769960_116907276143171_3978053186920382464_n.d4325c07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/55769960_116907276143171_3978053186920382464_n.jpg
// module id = 40
// module chunks = 0